import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import CastingCommon from '@utils/casting-common';

import ContentsTab   from 'contents_tab';

import InfluencerStatus  from './status';
import InfluencerAction  from './actions';
import InfluencerMessage from './message';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class InfluencerContents extends React.Component {
  render() {
    let base   = this.props.base;
    let detail = this.props.detail;
    
    let action_dot;
    
    let request_action = CastingCommon.getRequestAction(base, detail.insta_user_id, 'full_task');
    if( request_action != null ) action_dot = { width: '6px', height: '6px', top: '2px', right: '11px' };
    
    let deactive = ( request_action != null ) ? true : false;
    
    // タブリスト
    let tabs = [
      { id: 'message', name: 'メッセージ', html: <InfluencerMessage base={base} detail={detail} tab={this.props.side_tab} message_mode={this.props.message_mode} refresh_ev={this.props.refresh_ev.bind(this)} /> },
      { id: 'status',  name: 'ステータス', html: <InfluencerStatus base={base} detail={detail} tab={this.props.side_tab} refresh_ev={this.props.refresh_ev.bind(this)} /> },
      { id: 'action',  name: 'アクション', html: <InfluencerAction base={base} detail={detail} tab={this.props.side_tab} refresh_ev={this.props.refresh_ev.bind(this)} close_ev={this.props.close_ev.bind(this)} />, pop_mark: deactive },
    ];
    
    return (
      <div className={'influencer-contents-box tab-'+ this.props.side_tab}>
        <ContentsTab tabs={tabs} select={this.props.side_tab} font_size={14} className="contents-tab" update_ev={this.props.change_tab_ev.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerContents;